// extracted by mini-css-extract-plugin
export default {"actionIcon":"_k","menuItem":"al"};